import type { Sort, SortDirection } from '@ztechapps/common.contract'
import { DirectionEnum } from '../constants/DirectionEnum'
import type { ListField, SortValue } from '@ztechapps/common.hook'

export const useMongoSort = <T = any>({
  onSort,
  sortFields,
}: {
  onSort: ({
    sortString,
    sortObject,
    sortValue,
    sortFields,
  }: {
    sortString?: string
    sortObject: { sort: Sort<T> }
    sortValue?: SortValue
    sortFields?: ListField[]
  }) => any
  sortFields?: ListField[]
}) => {
  const directionConverter = (direction: DirectionEnum | string): SortDirection => {
    return direction?.toLowerCase?.() === DirectionEnum.asc ? 1 : -1
  }

  return ({ direction, activeSortField }) => {
    const activeDirection = directionConverter(direction)

    const sortObj = {
      sort: {
        [activeSortField.name]: activeDirection,
      } as Sort<T>,
    }

    const sortString = JSON.stringify(sortObj)
    const sortValue = { name: activeSortField.name, direction: activeDirection }

    onSort({ sortString, sortObject: sortObj, sortValue, sortFields })
  }
}
